import { useEffect } from 'react';
import { api } from '@/api/core';
import { useCaseCloningLock } from '@/hooks';
import {
  setSharedDataActiveBundleType,
  setSharedDataBundleId,
  BundleType,
  useAppDispatch,
  useAppSelector,
  selectSharedDataActiveBundleType,
} from '@/store';
import { DocumentReviewPage } from './DocumentReviewPage';
import { useGetPageIdInViewportOnInit } from './hooks';
import { useParams } from 'react-router';

export const LightBundlePageContainer = () => {
  const dispatch = useAppDispatch();
  const { caseId, lightBundleId } = useParams();

  const activeBundleType = useAppSelector(selectSharedDataActiveBundleType);

  useGetPageIdInViewportOnInit();
  useCaseCloningLock(caseId);

  useEffect(() => {
    dispatch(setSharedDataBundleId(lightBundleId || null));
    dispatch(setSharedDataActiveBundleType(BundleType.LIGHT));

    return () => {
      dispatch(setSharedDataBundleId(null));
      dispatch(setSharedDataActiveBundleType(null));
      dispatch(api.util.resetApiState());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lightBundleId]);

  if (activeBundleType !== BundleType.LIGHT) {
    return null;
  }

  return <DocumentReviewPage />;
};
